import { defineHierarchyChart } from '@rdrive/helper-chart-config';

// Issue breakdown by priority -> status, for @rdrive/plugin-chart-stacked-bar's
// StackedHorizontalBarChart (IA_ABSORPTION_PLAN Phase 4 step 12a; was
// components/charts/PriorityStackedBarChart.vue). Since Phase 5 step 5.1 a level table on
// `defineHierarchyChart` (@rdrive/helper-chart-config) — the generated queries equal the old
// hand-written ones (tooling/parity/hierarchy-chart/), and every filter value goes through
// escapeSql (rule 6). Rendered on the Analysis page.
//
// `status` is the terminal level and HAS a filter, so a click on a status bar filters by
// status + priority (the package base's terminal-level filter, as project-overview's status
// levels do). Under issue-analysis's own base that updater was never called: its terminal clicks
// were inert.

const STATUS_JOIN = 'JOIN status_templates s ON i.issueStatusId = s.id';

export function usePriorityChart({ chartName, filterContext, conn }) {
  return defineHierarchyChart({
    chartName,
    filterContext,
    conn,
    // `filteredIssues` exposes the tag column "BI-Priority" as `priority`; `issues` has only the
    // raw column. The unfiltered source — read only by the base's breadcrumb lookup, which a
    // terminal status selection makes reachable — carries the same alias, so both levels run on both.
    source: {
      table: (filtered) => (filtered ? 'filteredIssues' : '(SELECT *, "BI-Priority" AS priority FROM issues)'),
      alias: 'i',
    },
    status: { join: STATUS_JOIN },
    filter: { table: 'issues', keys: 'i.id' },
    levels: [
      {
        level: 'priority', titleKey: 'priority',
        id: 'i.priority', title: 'i.priority', where: 'i.priority IS NOT NULL',
        filter: { where: [['i."BI-Priority"', 'id']] },
      },
      {
        level: 'status', titleKey: 'status',
        id: 's.title', parentId: 'i.priority', title: 's.title', where: 'i.priority IS NOT NULL',
        orderBy: 'sort, s.title',
        filter: { joins: [STATUS_JOIN], where: [['s.title', 'id'], ['i."BI-Priority"', 'parentId']] },
      },
    ],
  });
}
